import { render, staticRenderFns } from "./partial.vue?vue&type=template&id=da2c0054&scoped=true"
import script from "./partial.vue?vue&type=script&lang=js"
export * from "./partial.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=da2c0054&prod&scoped=true&lang=css&external"
import style1 from "./partial.vue?vue&type=style&index=1&id=da2c0054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2c0054",
  null
  
)

export default component.exports